export default Object.freeze({
  DEFAULT: 'DEFAULT',
  NEW: 'NEW',
  MODIFIED: 'MODIFIED',
  DELETED: 'DELETED',
});
